export default import.meta.ROLLDOWN_FILE_URL_Q16Vkb8dkkryFQ2D0QY57w